import videoConnection from './videoConnection.vue';

import realtimeCall from './realtimeCall.vue';

let views = {
    videoConnection,
    realtimeCall
};

export default views;